import { ReactNode, lazy } from 'react'

const RefundProgramListPage = lazy(
  () => import('@/presentation/pages/refund/refund-program-list-page')
)

const RefundRequestPage = lazy(
  () => import('@/presentation/pages/refund/request/refund-request-page')
)

export const makeRefundProgramListPage = (): ReactNode => {
  return <RefundProgramListPage />
}

export const makeRefundRequestPage = (): ReactNode => {
  return <RefundRequestPage />
}
